import React from "react"
import { Link } from "react-router-dom"

const Privacidad = () => {
    return (
        <main style={wrap}>
            <Link to="/" style={backLink}>← Volver al inicio</Link>
            <h1 style={h1}>Política de Privacidad</h1>
            <p style={meta}>Última actualización: 22 de mayo de 2026</p>

            <p style={p}>En <strong>ADETRES SOFTWARE, SL</strong> (en adelante, "AD3", "nosotros" o "el Responsable")
                nos comprometemos a proteger la privacidad de los usuarios y a tratar sus datos personales conforme al
                Reglamento (UE) 2016/679 General de Protección de Datos (RGPD), a la Ley Orgánica 3/2018 de Protección de
                Datos Personales y garantía de los derechos digitales (LOPDGDD) y a la Ley 34/2002 de Servicios de la
                Sociedad de la Información y de Comercio Electrónico (LSSI-CE).</p>

            <h2 style={h2}>1. Responsable del tratamiento</h2>
            <table style={table}><tbody>
                <tr><th style={th}>Razón social</th><td style={td}>ADETRES SOFTWARE, SL</td></tr>
                <tr><th style={th}>NIF</th><td style={td}>B16414161</td></tr>
                <tr><th style={th}>Domicilio</th><td style={td}>Calle Telers 5, Pasillo B, 2ª planta, Local 3 — 08221 Terrassa (Barcelona)</td></tr>
                <tr><th style={th}>Correo electrónico</th><td style={td}><a style={aLink} href="mailto:info@ad3soft.com">info@ad3soft.com</a></td></tr>
                <tr><th style={th}>Sitio web</th><td style={td}><a style={aLink} href="https://ad3soft.com">https://ad3soft.com</a></td></tr>
            </tbody></table>

            <h2 style={h2}>2. Datos que tratamos y finalidades</h2>
            <p style={p}>Tratamos los datos personales que nos facilitas voluntariamente y los que se generan durante tu
                navegación, con las siguientes finalidades:</p>
            <table style={table}><tbody>
                <tr><th style={th}>Tratamiento</th><th style={th}>Datos</th><th style={th}>Finalidad</th><th style={th}>Base de legitimación</th></tr>
                <tr>
                    <td style={td}>Consultas y solicitudes de contacto</td>
                    <td style={td}>Nombre, correo electrónico y el contenido de tu mensaje</td>
                    <td style={td}>Atender tu solicitud, consulta o petición de información comercial</td>
                    <td style={td}>Consentimiento del interesado (art. 6.1.a RGPD) y/o aplicación de medidas precontractuales (art. 6.1.b RGPD)</td>
                </tr>
                <tr>
                    <td style={td}>Relación comercial y contractual</td>
                    <td style={td}>Datos identificativos, fiscales y de facturación</td>
                    <td style={td}>Prestación de los servicios contratados, facturación y obligaciones legales asociadas</td>
                    <td style={td}>Ejecución de un contrato (art. 6.1.b) y cumplimiento de obligaciones legales (art. 6.1.c)</td>
                </tr>
                <tr>
                    <td style={td}>Navegación por el sitio web</td>
                    <td style={td}>Dirección IP e identificadores de cookies técnicas</td>
                    <td style={td}>Garantizar el funcionamiento técnico y la seguridad del sitio</td>
                    <td style={td}>Interés legítimo (art. 6.1.f RGPD)</td>
                </tr>
            </tbody></table>

            <h2 style={h2}>3. Plazo de conservación</h2>
            <p style={p}>Conservaremos tus datos durante el tiempo necesario para cumplir la finalidad para la que se
                recabaron y, posteriormente, durante los plazos legalmente exigidos (por ejemplo, los plazos fiscales y
                mercantiles aplicables). Los datos de consultas que no deriven en relación contractual se conservarán el
                tiempo imprescindible para gestionarlas y, como máximo, durante un (1) año, salvo que solicites su
                supresión antes.</p>

            <h2 style={h2}>4. Destinatarios de los datos</h2>
            <p style={p}>Con carácter general, tus datos no se cederán a terceros, salvo obligación legal. Pueden acceder a
                ellos, como encargados del tratamiento, los proveedores de servicios que AD3 necesita para operar (por
                ejemplo, servicios de alojamiento web, correo electrónico o herramientas de gestión), con quienes se han
                suscrito los correspondientes contratos de encargo de tratamiento conforme al artículo 28 del RGPD.</p>

            <h2 style={h2}>5. Transferencias internacionales</h2>
            <p style={p}>Si se emplean herramientas cuyos servidores se ubican fuera del Espacio Económico Europeo (por
                ejemplo, determinados servicios de analítica o de mensajería), dichas transferencias se ampararán en las
                garantías previstas en el RGPD (decisiones de adecuación o cláusulas contractuales tipo de la Comisión
                Europea).</p>

            <h2 style={h2}>6. Tus derechos</h2>
            <p style={p}>Puedes ejercer en cualquier momento los siguientes derechos dirigiéndote a{" "}
                <a style={aLink} href="mailto:info@ad3soft.com">info@ad3soft.com</a>, indicando el derecho que deseas
                ejercer y adjuntando copia de un documento que acredite tu identidad:</p>
            <ul style={ul}>
                <li style={li}><strong>Acceso</strong>: conocer qué datos tuyos tratamos.</li>
                <li style={li}><strong>Rectificación</strong>: corregir datos inexactos o incompletos.</li>
                <li style={li}><strong>Supresión</strong> ("derecho al olvido"): solicitar la eliminación de tus datos.</li>
                <li style={li}><strong>Oposición</strong>: oponerte a determinados tratamientos.</li>
                <li style={li}><strong>Limitación</strong> del tratamiento en los supuestos previstos por la ley.</li>
                <li style={li}><strong>Portabilidad</strong>: recibir tus datos en un formato estructurado y de uso común.</li>
                <li style={li}><strong>Retirar el consentimiento</strong> prestado, sin que ello afecte a la licitud del tratamiento previo.</li>
            </ul>
            <p style={p}>Si consideras que el tratamiento de tus datos no se ajusta a la normativa, tienes derecho a
                presentar una reclamación ante la <strong>Agencia Española de Protección de Datos</strong> (
                <a style={aLink} href="https://www.aepd.es">www.aepd.es</a>).</p>

            <h2 style={h2}>7. Medidas de seguridad</h2>
            <p style={p}>AD3 aplica las medidas técnicas y organizativas apropiadas para garantizar un nivel de seguridad
                adecuado al riesgo, evitando la pérdida, alteración o acceso no autorizado a los datos, de acuerdo con el
                estado de la técnica.</p>

            <h2 style={h2}>8. Cambios en esta política</h2>
            <p style={p}>Esta Política de Privacidad puede actualizarse para adaptarse a cambios normativos o a la propia
                actividad de AD3. Te recomendamos revisarla periódicamente; la fecha de la última actualización figura al
                inicio del documento.</p>

            <p style={footerNote}>© 2026 ADETRES SOFTWARE, SL · NIF B16414161 · Terrassa (Barcelona).</p>
        </main>
    )
}
export default Privacidad

const wrap: any = { maxWidth: 820, marginLeft: "auto", marginRight: "auto", padding: window.innerWidth <= 1058 ? "0 16px 60px" : "0 24px 80px", lineHeight: 1.65, color: "#1a1a2e" }
const backLink: any = { display: "inline-block", marginBottom: 18, color: "#555", textDecoration: "none", fontSize: 14 }
const h1: any = { fontSize: 30, margin: "0 0 6px" }
const meta: any = { color: "#8a8a96", fontSize: 14, marginBottom: 28 }
const h2: any = { fontSize: 20, margin: "34px 0 10px", paddingTop: 10, borderTop: "1px solid #e3e3e8" }
const p: any = { color: "#555" }
const ul: any = { paddingLeft: 22 }
const li: any = { color: "#555", marginBottom: 4 }
const table: any = { width: "100%", borderCollapse: "collapse", margin: "14px 0", fontSize: 15 }
const th: any = { textAlign: "left", padding: "9px 12px", border: "1px solid #e3e3e8", verticalAlign: "top", background: "#f6f7f9", color: "#1a1a2e" }
const td: any = { textAlign: "left", padding: "9px 12px", border: "1px solid #e3e3e8", verticalAlign: "top", color: "#555" }
const aLink: any = { color: "#2b6cb0" }
const footerNote: any = { marginTop: 44, paddingTop: 18, borderTop: "1px solid #e3e3e8", fontSize: 13, color: "#8a8a96" }
